export const navs = [
  { name: 'Dashboard', rolesAllowed: ['admin', 'engineer', 'manager', 'quality'], path: '/dashboard' },
  { name: 'Commissioning Forms', rolesAllowed: ['admin', 'engineer'], path: '/allforms/' },
  { name: 'Create Forms', rolesAllowed: ['admin','manager','engineer'], path: '/formChecklist/' },
  { name: 'Form List', rolesAllowed: ['admin', 'engineer', 'manager', 'quality'], path: '/formList/' },
  { name: 'Contractor View', rolesAllowed: ['admin','manager','contractor'], path: '/contractorView/' },
  { name: 'User Management', rolesAllowed: ['admin','engineer','manager'], path: '/usermanagement' },
  { name: 'Assignment', rolesAllowed: ['admin'], path: '/assignment' },
];
